import { render, staticRenderFns } from "./RequestWorkPackageListElement.vue?vue&type=template&id=13966791&scoped=true&"
import script from "./RequestWorkPackageListElement.vue?vue&type=script&lang=js&"
export * from "./RequestWorkPackageListElement.vue?vue&type=script&lang=js&"
import style0 from "./RequestWorkPackageListElement.vue?vue&type=style&index=0&id=13966791&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13966791",
  null
  
)

export default component.exports
import {QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip}, component.options.components || {})
